module.exports = __webpack_public_path__ + "img/19.1709e665.jpg";